import { useMemo } from "react";

import { CaseChatServiceV2 } from "../services/caseChatServiceV2";
import { useAPI } from "./useAPI";

export const useCaseChatService = () => {
  const api = useAPI("v2");
  return useMemo(() => new CaseChatServiceV2(api), [api]);
};
